<div class="relative inline-block" [class.animate-pulse]="isAnimating()">
    @if (hasUnread()) {
    <icon-bell-filled 
        [size]="size" 
        [class]="'text-main-500 ' + (shouldAnimate ? 'animate-bounce' : '')" />
    } @else {
    <icon-bell 
        [size]="size" 
        [class]="'text-gray-500 hover:text-gray-700 ' + (shouldAnimate ? 'animate-ring' : '')" />
    }
      
      <!-- Badge de compteur -->
    @if (unreadCount > 0) {
    <span 
        class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 font-medium animate-in zoom-in duration-200"
        [class.animate-pulse]="shouldAnimate">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
    </span>
    }

    <!-- Indicateur de point rouge pour nouvelles notifications -->
    @if (hasNewNotification && unreadCount === 0) {
    <span class="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
    <span class="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
    }
</div>